import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 2 }

import type { TranslationPart } from 'composables/useTranslationLinkParser';

interface Props {
    parts: TranslationPart[];
    linkSize?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TranslationText',
  props: {
    parts: {},
    linkSize: { default: undefined }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_CompassLink = _resolveComponent("CompassLink")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.parts, (part, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
      (part.type === 'br')
        ? (_openBlock(), _createElementBlock("br", _hoisted_1))
        : (part.type === 'link')
          ? (_openBlock(), _createBlock(_component_CompassLink, {
              key: 1,
              label: part.label,
              link: part.url,
              size: __props.linkSize,
              target: "_blank"
            }, null, 8 /* PROPS */, ["label", "link", "size"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(part.content), 1 /* TEXT */))
    ], 64 /* STABLE_FRAGMENT */))
  }), 128 /* KEYED_FRAGMENT */))
}
}

})